/** Sigla di provincia italiana: due lettere maiuscole. */
export const PROVINCIA_REGEX = /^[A-Z]{2}$/;
